interface ConditonalWrapperProps extends React.PropsWithChildren {
  when: boolean
  wrapper: (children: React.ReactNode) => React.ReactNode
}

export const ConditonalWrapper = ({ when, wrapper, children }: ConditonalWrapperProps) =>
  when ? wrapper(children) : children
